import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=940478d2&scoped=true"
import script from "./TableCustom.vue?vue&type=script&lang=js"
export * from "./TableCustom.vue?vue&type=script&lang=js"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=940478d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940478d2",
  null
  
)

export default component.exports